import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Calendar from '../page_components/coach/Calendar';
import Diary from '../page_components/coach/Diary';
// import Messages from '../page_components/player/registered/Messages';
import MySportSubNavigation from './MySportSubNavigation';
import SetGoals from './SetGoals';
import FitnessTest from './FitnessTest';
import Feedback from '../page_components/player/registered/Feedback';
import Task from '../page_components/coach/Task';
import MedicalQns from './MedicalQns';

const useStyles = makeStyles((theme) => ({
  layout: {
    width: 'auto',
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(3),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '18px',
    },
  },
  bottomBar: {
    width: 'auto',
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      width: '300',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
}));

function getContent(value) {
  switch (value) {
    case 0:
      return <Calendar />;
    // case 1:
    //   return <Messages />;
    case 1:
      return <Diary />;
    case 2:
      return <SetGoals />;
    case 3:
      return <FitnessTest />;
    case 4:
      return <Feedback />;
    case 5:
      return <Task />;
    case 6:
      return <MedicalQns />;
    default:
      throw new Error('Unknown step');
  }
}

export default function MySport() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const onChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <main className={classes.layout}>
      <Paper className={classes.paper}>
        <MySportSubNavigation
          value={value}
          onChange={onChange}
          className={classes.bottomBar}
        />
        {getContent(value)}
      </Paper>
    </main>
  );
}
